import Modal from "./Index";

import { data } from "../../data";
import { OptionButton } from "./Buttons";
import H2 from "../Typography/Headings";
import { useContext } from "react";
import { Context } from "../../store";
import {
  setIndex,
  toggleChapters,
} from "../../store/reducer";

const ChaptersModal = () => {
  const [, dispatch] = useContext(Context);

  const onButtonClick = (idx) => () => {
    dispatch(setIndex(idx));
    dispatch(toggleChapters());
  };

  return (
    <div className="max-w-3xl w-full md:max-h-96 h-full overflow-y-scroll pb-4 scroll-bar">
      <H2 text="Chapters" />
      <div className="stack chapters px-4">
        {data.map((chapter, index) => {
          return (
            <OptionButton
              key={chapter.section}
              text={chapter.title}
              index={index}
              onClick={onButtonClick(index)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Modal(ChaptersModal);
